type Props = {
  label: string
  value: number
  max?: number
}

const PIPS = 5

export function SkillBar({ label, value, max = PIPS }: Props) {
  const filled = Math.max(0, Math.min(max, value))
  return (
    <div className="flex items-center gap-2">
      <span className="w-24 shrink-0 text-[10px] uppercase tracking-wider text-stone-400">
        {label}
      </span>
      <div className="flex flex-1 gap-0.5">
        {Array.from({ length: max }).map((_, i) => (
          <span
            key={i}
            className={`h-2 flex-1 rounded-sm ${
              i < filled
                ? 'bg-amber-500'
                : 'bg-stone-800 ring-1 ring-inset ring-stone-700'
            }`}
          />
        ))}
      </div>
      <span className="w-6 shrink-0 text-right font-mono text-[10px] text-stone-400">
        {filled}/{max}
      </span>
    </div>
  )
}
